import { useCallback, useState } from 'react';

export function getSortIndicator(sorting, column) {
  if (!sorting || sorting.sort_by !== column) return '';
  return sorting.sort_direction === 'asc' ? ' ▲' : ' ▼';
}

export function toggleServerSort(prev, column) {
  if (prev.sort_by === column) {
    return {
      ...prev,
      sort_direction: prev.sort_direction === 'asc' ? 'desc' : 'asc',
    };
  }
  return { sort_by: column, sort_direction: 'asc' };
}

export function useServerTableSort(defaultSortBy, defaultDirection = 'desc') {
  const [sorting, setSorting] = useState({
    sort_by: defaultSortBy,
    sort_direction: defaultDirection,
  });

  const handleSortChange = useCallback((column) => {
    setSorting((prev) => toggleServerSort(prev, column));
  }, []);

  const getIndicator = useCallback(
    (column) => getSortIndicator(sorting, column),
    [sorting],
  );

  return { sorting, handleSortChange, getSortIndicator: getIndicator };
}
